import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Flag from '../../../elements/Flag';
import Dropdown from '../../../blocks/Dropdown';
import Button from '../../../elements/Button';
import { countriesArr } from './assets/countries';
import dropdownIconSvg from '../../../icons/dropdown-down-arrow.svg';

const PhoneCodeSpan = styled.span`
  color: ${(props) => props.theme.palette.label};
`;

const CountryListWrap = styled(Dropdown.ListWrap)`
  max-height: 220px;
  overflow: auto;
`;

const CountryListItem = styled(Dropdown.ListItem)`
  font-weight: normal;
  text-align: left;
`;

const Icon = styled.img`
  width: 8px;
  height: 8px;
  display: inline-block;
  transform: translateY(-2px);
`;

class CountrySelector extends React.PureComponent {
  state = {
    open: false,
    selectedIsoCode: 'us',
  };

  _handleItemClick = (isoCode, phoneCode) => {
    const { _countrySelectHandler } = this.props;

    this.setState({ open: false, selectedIsoCode: isoCode });
    _countrySelectHandler(phoneCode);
  };

  _openList = () => {
    this.setState((prevState) => ({
      open: !prevState.open,
    }));
  };

  _populateList = (countries) => countries.map((country) => {
    const name = country[0];
    const isoCode = country[1];
    const phoneCode = country[2];

    return (
      <CountryListItem
        key={isoCode}
        onClick={() => {
          this._handleItemClick(isoCode, phoneCode);
        }}
      >
        <Flag isoCode={isoCode} />
        {name}
          &nbsp;
        <PhoneCodeSpan>
          +
          {phoneCode}
        </PhoneCodeSpan>
      </CountryListItem>
    );
  });

  render() {
    const { open, selectedIsoCode } = this.state;

    return (
      <Dropdown>
        <Button modifiers={['plain']} onClick={this._openList}>
          <Flag isoCode={selectedIsoCode} />
          <Icon src={dropdownIconSvg} />
        </Button>
        <CountryListWrap open={open}>{this._populateList(countriesArr)}</CountryListWrap>
      </Dropdown>
    );
  }
}

CountrySelector.propTypes = {
  _countrySelectHandler: PropTypes.func.isRequired,
};

export default CountrySelector;
